import React, {useState, useEffect, Fragment} from 'react'
import {Table, List, Container, Popup, Icon, Loader, Transition, Button} from 'semantic-ui-react'
import {useFirestore, useFirebase} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import {Channelselect} from '../channelselect';
import {env} from '../../../constants/Environment';
import * as RouterActions from '../../../actions/RouterActions';
import * as ToplistsActions from '../../../actions/canvas/ToplistsActions';
import {CanvasNavigation} from '../Navigation'
import {Schedule} from '../../schedule/schedule'
import {Listview} from './listview';
import {Edit} from './edit';
import {fg, bg} from '../../../constants/ScheduleColors'

const moment = require('moment');

export default function Toplists(props){
    const firestore = useFirestore();
    const firebase = useFirebase();
    const dispatch = useDispatch();
    const channel = 'uatretail';

    let isInitialized = useSelector(({canvas_toplists}) => typeof canvas_toplists.unsubscribe === 'function');
    let editId = useSelector(({canvas_toplists}) => canvas_toplists.edit);
    let selected = useSelector(({canvas_toplists}) => (canvas_toplists.selected === null)?null:canvas_toplists.toplists[canvas_toplists.selected]);
    let toplists = useSelector(({canvas_toplists}) => canvas_toplists.toplists);

    useEffect(() => {
        if(!isInitialized){
            dispatch(ToplistsActions.load(firestore, channel));
        }
    }, [isInitialized]);

    const saving = false;
    const message = null;

    const saveSchedule = (dateStart, data) => {
        var transformed = {};
        for(var slotIdx in data){
            var slot = data[slotIdx];

            if(typeof slot.items !== 'undefined')
                slot.items.forEach((item) => {
                    let t = item.meta.type;

                    if(typeof item.deleted !== 'undefined' && item.deleted)
                        return;

                    if(typeof transformed[t] === 'undefined')
                        transformed[t] = {};

                    if(typeof transformed[t][slotIdx] === 'undefined')
                        transformed[t][slotIdx] = [];

                    transformed[t][slotIdx].push({
                        id: item.meta.id,
                        'active-from': new Date(item.start * 1000),
                        'active-to': new Date(item.end * 1000)
                    });
                });
        }

        dispatch(ToplistsActions.save_schedule(firebase, channel, "toplists", dateStart, transformed));
    }

    return (
        <CanvasNavigation breadcrumb={[
            {
                'caption': 'Top-Angebot',
                'href': 'canvas/toplists/'
            }
        ]}>
            {
                (editId !== null)?
                    <Edit id={editId} channel={channel} />
                :null
            }
            <div>
                <div style={{
                        display: 'flex',
                        position: 'fixed',
                        left: '0px',
                        right: '0px',
                        bottom: 0,
                        top: '41px'
                    }}>
                        <div style={{
                            backgroundColor: '#EEEEEE',
                            borderRight: '1px solid #CCCCCC',
                            width: '300px',
                            height: '100%',
                            flexGrow: 0,
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div style={{
                                flexGrow: 1,
                                overflow: 'auto'
                            }}>
                                <Listview />
                            </div>
                            <div style={{
                                backgroundColor: '#555555',
                                padding: '0.5em'
                            }}>
                                <Button icon color="green" fluid labeled labelPosition="left" onClick={(e) => dispatch(ToplistsActions.create())}><Icon name="plus" /> Neue Liste</Button>
                            </div>
                        </div>
                        <div style={{
                            flexGrow: 1,
                            display: 'flex'
                        }}>
                                <Transition.Group animation='slide down' duration={500}>
                                {
                                    (message)?
                                        <div style={{
                                            position: 'fixed',
                                            top: '40px',
                                            left: '50%',
                                            width: '30%',
                                            marginLeft: '-15%',
                                            backgroundColor: 'rgba(0,0,0,0.8)',
                                            color: '#FFFFFF',
                                            padding: '10px',
                                            textAlign: 'center',
                                            fontSize: '90%',
                                            zIndex: 10
                                        }}>
                                            {message}
                                        </div>
                                    :null
                                }
                                </Transition.Group>
                            {
                                (saving)?
                                    <div style={{
                                        flexGrow: 1,
                                        overflow: 'auto',
                                        paddingTop: '20px'
                                    }}><Loader active inline='centered' /></div>
                                :
                                    <Schedule items={toplists} start={moment().startOf('week').add(1, 'days').format('X')} end={moment().endOf('week').add(1, 'days').format('X')} item={(selected === null)?null:{
                                        name: selected.name,
                                        id: selected.id,
                                        type: 1,
                                        saving: saving,
                                        coloridx: selected.coloridx
                                    }} id={"toplists"} fetch_schedule={function(){
                                            return ToplistsActions.fetch_schedule(...[firestore, channel, ...arguments]);
                                        }} save_schedule={(scheduleId, start, end, lottery, channel, data) => {
                                        saveSchedule(start, data);
                                    }} onSelectItem={(item) => {
                                        dispatch(ToplistsActions.select(item.meta.id));
                                    }} />
                                
                            }
                        </div>
                </div>
            </div>
        </CanvasNavigation>
    );
}